import React, { useEffect, useState } from "react";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import ModuleTable from "../../../components/Settings/academy/ModuleTable";
import ModuleModal from "../../../components/Settings/academy/modal/ModuleModal";
import { useLocation } from "react-router-dom";
import useAcademy from "../../../hooks/useAcademy";
import Loading from "../../../components/animation/loading";

export default function Module() {
  const [openModule, setOpenModule] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modules, setModules] = useState(null);
  const location = useLocation();
  const { training } = location.state || {};
  const queryParams = new URLSearchParams(location.search);
  const trainingID = queryParams.get("trainingID");

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [triggerFetchModule, setTriggerFetchModule] = useState(0);

  const { getTrainingModule } = useAcademy();

  const fetchModules = async () => {
    setLoading(true);
    try {
      const offset = (page - 1) * limit;
      const res = await getTrainingModule(
        setLoading,
        trainingID,
        limit,
        offset
      );
      setModules(res);
      const total = res?.meta?.total || 0;
      const totalPages = Math.ceil(total / limit);

      if (page > totalPages && totalPages > 0) {
        setPage(totalPages);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
// triger fetch module
  useEffect(() => {
    fetchModules();
  }, [triggerFetchModule, page, limit]);

  return (
    <>
      <div className="flex flex-col space-y-10">
        <div className="flex flex-col space-y-6">
          <div className="flex justify-between">
            <div className="flex space-x-3 items-center">
              <KeyboardBackspaceIcon
                onClick={() => window.history.back()}
                className="cursor-pointer"
              />
              <h5 className="text-black">{training?.title}</h5>
              <div className="hidden md:flex ">
                <BorderColorIcon fontSize="small" className="cursor-pointer " />
              </div>
            </div>

            <button
              onClick={() => setOpenModule(true)}
              className="bg-theme1 text-white px-4 whitespace-nowrap py-2 rounded-lg hover:bg-blue-700 transition"
            >
              Add Module
            </button>
          </div>
          <p className="text-[#2E2E32]">{training?.description}</p>
        </div>

        {loading ? (
          <div className="flex justify-center items-center">
            <Loading />
          </div>
        ) : modules?.data?.length > 0 ? (
          <ModuleTable
            modules={modules}
            training={training}
            onTrigger={() => setTriggerFetchModule((t) => t + 1)}
            page={page}
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
          />
        ) : (
          <div className="flex justify-center items-center">
            No modules found in this training.
          </div>
        )}
      </div>

      {openModule && (
        <ModuleModal
          trainingID={trainingID}
          setOpenModule={setOpenModule}
          onTrigger={() => setTriggerFetchModule((t) => t + 1)}
        />
      )}
    </>
  );
}
